import React from 'react';

const SvgAccessLevels = props => (
  <svg width={'100%'} viewBox="0 0 32 32" {...props}>
    <defs>
      <style>
        {'.access_levels_svg__a{fill:none;stroke:#acacac;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
      </style>
    </defs>
    <g transform="translate(-360)">
      <path
        className="access_levels__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M365 22v-1a2 2 0 012-2h18a2 2 0 012 2v1M376 22v-5"
      />
      <rect
        className="access_levels__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        width={8}
        height={6}
        rx={1}
        transform="translate(372 7)"
      />
      <path fill="none" d="M360 0h32v32h-32z" />
      <path
        className="access_levels__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M379 7V5a3 3 0 00-3-3 3 3 0 00-3 3v2"
      />
      <circle
        className="access_levels__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        cx={2}
        cy={2}
        r={2}
        transform="translate(363 26)"
      />
      <circle
        className="access_levels__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        cx={2}
        cy={2}
        r={2}
        transform="translate(374 26)"
      />
      <circle
        className="access_levels__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        cx={2}
        cy={2}
        r={2}
        transform="translate(385 26)"
      />
    </g>
  </svg>
);

export default SvgAccessLevels;
